import { useTheme } from "@emotion/react";
import { FormControl, Slider, Stack } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { useApi } from "../../contexts/ApiContext";
import { InputProps } from "./InputProps";
import TextInput from "./TextInput";
import FormLabel from "../FormLabel";
const StyledSlider = styled(Slider)`
  margin: 8px 0;

  .MuiSlider-thumb {
    color: #ffffff !important;
    border: 2px solid #000000 !important;
  }
`;

const StyledTextField = styled(TextInput)`
  margin: 8px 0;
  width: 80px;

  & .MuiFormHelperText {
    display: none;
    background-color: transparent;
  }
`;

interface SliderInputProps extends Omit<Omit<InputProps, "value">, "onChange"> {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  postfix?: string;
  manual?: boolean;
}

const SliderInput: React.FC<SliderInputProps> = ({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  error,
  helperText,
  postfix,
  manual = false,
}) => {
  const theme: any = useTheme();

  const handleSliderChange = (_event: Event, newValue: number | number[]) => {
    onChange(newValue as number);
  };

  const handleInputChange = (value: number | string) => {
    const newValue: number = value as number;
    if ((manual && !isNaN(+value)) || (newValue >= min && newValue <= max)) {
      onChange(newValue);
    }
  };

  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  return (
    <FormControl disabled={isDisabled}>
      <FormLabel error={error}>{label}</FormLabel>
      <Stack gap={5} alignItems="center" direction={"row-reverse"}>
        <StyledSlider
          value={value}
          onChange={handleSliderChange}
          aria-labelledby="slider-label"
          min={min}
          max={max}
          step={step}
          sx={{
            "& .MuiSlider-thumb": {
              color: error
                ? theme.palette.error.main
                : theme.palette.primary.main,
            },
            "& .MuiSlider-track": {
              color: error
                ? theme.palette.error.main
                : theme.palette.primary.main,
            },
            "& .MuiSlider-rail": {
              color: theme.palette.grey[400],
            },
            width: "100%",
          }}
        />
        <StyledTextField
          label=""
          value={value.toString()}
          onChange={handleInputChange}
          adornment={postfix}
          sx={{ width: "100%" }}
          error={error}
          helperText={error ? helperText : ""}
        />
      </Stack>
    </FormControl>
  );
};

export default SliderInput;
